(function () {
  function isPreorderItem(item) {
    return !!(item.properties && item.properties['_essential_preorder_campaign_id']);
  }

  function isPreorderPage() {
    return !!document.querySelector('.essential-preorder-add-to-cart-button-default');
  }

  async function getCartItems() {
    const res = await window.__nativeFetch('/cart.js');
    const cart = await res.json();
    return cart.items || [];
  }

  function extractVariantId(config) {
    const body = config?.body;
    if (!body) return null;
    if (typeof body === 'string') {
      try {
        const parsed = JSON.parse(body);
        return parsed.id || parsed.variant_id || null;
      } catch {}
      try {
        return new URLSearchParams(body).get('id') || new URLSearchParams(body).get('variant_id') || null;
      } catch {}
    }
    if (body instanceof FormData) {
      return body.get('id') || body.get('variant_id') || null;
    }
    return null;
  }

  async function checkCart(newIsPreorder) {
    const items = await getCartItems();
    if (items.length === 0) return true;

    const cartHasPreorder = items.some(isPreorderItem);
    const cartHasNormal = items.some(i => !isPreorderItem(i));

    if (newIsPreorder && cartHasNormal) {
      alert("⚠️ Votre panier contient des articles en vente normale.\nVous ne pouvez pas ajouter un article en pré-commande en même temps.\n\nFinalisez votre commande ou videz votre panier d'abord.");
      return false;
    }
    if (!newIsPreorder && cartHasPreorder) {
      alert("⚠️ Votre panier contient des articles en pré-commande.\nVous ne pouvez pas ajouter un article en vente normale en même temps.\n\nFinalisez votre commande ou videz votre panier d'abord.");
      return false;
    }
    return true;
  }

  function installGuard() {
    window.__nativeFetch = window.fetch.bind(window);

    window.fetch = async function (...args) {
      const [resource, config] = args;
      const url = typeof resource === 'string' ? resource : resource?.url || '';

if (url.includes('/cart/add') && config?.method?.toUpperCase() === 'POST' && !config?.headers?.['X-Carousel-Add']) {        try {
          const variantId = extractVariantId(config);
          if (variantId) {
            const newIsPreorder = isPreorderPage();
            const allowed = await checkCart(newIsPreorder);
            if (!allowed) {
              return new Response(JSON.stringify({ error: 'mixed_cart', status: 422 }), {
                status: 422,
                headers: { 'Content-Type': 'application/json' }
              });
            }
          }
        } catch (err) {
          console.error('[PreorderGuard]', err);
        }
      }

      return window.__nativeFetch.apply(this, args);
    };

    console.log('[PreorderGuard] ✅ Installé avec succès');
  }

  if (document.readyState === 'complete') {
    installGuard();
  } else {
    window.addEventListener('load', installGuard);
  }
  // Recharger la page quand un article est supprimé pour mettre à jour le carrousel
  var originalFetchForRemove = window.__nativeFetch || window.fetch;
  window.addEventListener('load', function() {
    var nativeFetch = window.__nativeFetch || window.fetch;
    var wrappedFetch = window.fetch;
    window.fetch = async function(...args) {
      var url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
      var result = await wrappedFetch.apply(this, args);
      if (url.includes('/cart/change') || url.includes('/cart/update')) {
        fetch('/cart.js').then(r => r.json()).then(cart => {
          if (cart.item_count >= 0) setTimeout(() => window.location.reload(), 300);
        });
      }
      return result;
    };
  });
})();